// ========================================
// JAVASCRIPT PARA MEGA-MENU DE ROUPAS
// ========================================

document.addEventListener('DOMContentLoaded', function() {
	// Elementos do mega-menu
	const roupasButton = document.querySelector('[data-target="headerMegaMenu:roupas"]');
	const roupasMenu = document.getElementById('headerMegaMenu:roupas');
	
	console.log('Mega Menu Debug:', { roupasButton, roupasMenu });
	
	if (!roupasButton || !roupasMenu) {
		console.log('Mega Menu não encontrado');
		return;
	}
	
	// Estado do menu
	let isMenuOpen = false;
	
	// Função para abrir o menu
	function openMenu() {
		if (isMenuOpen) return;
		
		// Calcular a altura do header para posicionar o mega-menu corretamente
		const header = document.querySelector('.header');
		const headerHeight = header ? header.offsetHeight : 0;
		
		isMenuOpen = true;
		roupasButton.setAttribute('aria-expanded', 'true');
		roupasMenu.style.display = 'block';
		roupasMenu.style.top = headerHeight + 'px'; // Posicionar abaixo do header
		
		// Adicionar classe ativa imediatamente
		roupasMenu.classList.add('is-active');
	}
	
	// Função para fechar o menu
	function closeMenu() {
		if (!isMenuOpen) return;
		
		isMenuOpen = false;
		roupasButton.setAttribute('aria-expanded', 'false');
		roupasMenu.classList.remove('is-active');
		
		// Esconder o menu imediatamente
		roupasMenu.style.display = 'none';
	}
	
	// Event listeners para o botão
	roupasButton.addEventListener('click', function(e) {
		e.preventDefault();
		
		if (isMenuOpen) {
			closeMenu();
		} else {
			openMenu();
		}
	});
	
	// Fechar menu ao clicar fora
	document.addEventListener('click', function(e) {
		if (!roupasMenu.contains(e.target) && !roupasButton.contains(e.target)) {
			closeMenu();
		}
	});
	
	// Fechar menu ao pressionar ESC
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && isMenuOpen) {
			closeMenu();
		}
	});
	
	// Fechar menu ao redimensionar a tela
	window.addEventListener('resize', function() {
		if (isMenuOpen) {
			closeMenu();
		}
	});
	
	// Hover para abrir o menu (opcional)
	roupasButton.addEventListener('mouseenter', function() {
		openMenu();
	});
	
	// Manter menu aberto quando hover no próprio menu
	roupasMenu.addEventListener('mouseenter', function() {
		// Não fechar automaticamente
	});
	
	// Fechar menu quando sair da área
	roupasMenu.addEventListener('mouseleave', function() {
		closeMenu();
	});
	
	// Fechar menu quando sair do botão
	roupasButton.addEventListener('mouseleave', function() {
		// Pequeno delay para permitir mover o mouse para o menu
		setTimeout(() => {
			if (!roupasMenu.matches(':hover') && !roupasButton.matches(':hover')) {
				closeMenu();
			}
		}, 100);
	});
});
